import { useStore } from 'vuex';

function getContrastColor(hexColor: string): string {
   let hex = hexColor.replace('#', '');

   if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
   }

   const r = parseInt(hex.slice(0, 2), 16);
   const g = parseInt(hex.slice(2, 4), 16);
   const b = parseInt(hex.slice(4, 6), 16);

   return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#ffffff';
}

export function useColorScheme() {
   const store = useStore();

   async function applyTenantColors(tenant: any) {
      if (!tenant) return;

      // Set CSS custom properties for colors
      if (tenant.primary_color_code) {
         document.documentElement.style.setProperty('--primaryColor', tenant.primary_color_code);
         document.documentElement.style.setProperty('--primaryColorContrast', getContrastColor(tenant.primary_color_code));
      }
      if (tenant.header_color_code) {
         document.documentElement.style.setProperty('--headerColor', tenant.header_color_code);
      }
      if (tenant.background_color_code) {
         document.documentElement.style.setProperty('--bgColor', tenant.background_color_code);
         document.documentElement.style.setProperty('--bgColorContrast', getContrastColor(tenant.background_color_code));
      }

      // Load and set logo
      store.commit('setLogo', tenant.logo_url || null);
   }

   function setBackgroundImage(routeName: string | symbol | null | undefined, isDesktop: boolean) {
      const journey = store.state.journeyModule.journey;
      const submission = store.state.journeyModule.submission;

      const backgroundImageUrl = journey?.background_image_url || submission?.journey?.background_image_url;

      const backgroundElement = document.getElementById('backgroundimage');
      if (!backgroundElement) return;

      const backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--bgColor').trim() || '#ffffff';
      const currentBg = backgroundElement.style.getPropertyValue('--bg');

      // Clear existing styles if switching contexts
      if (currentBg) {
         backgroundElement.style.removeProperty('--bg');
         backgroundElement.style.removeProperty('--bgColor');
      }

      // Apply background with gradient overlay
      if (backgroundImageUrl) {
         backgroundElement.style.setProperty(
            '--bg',
            `linear-gradient(${backgroundColor}AA, ${backgroundColor}AA), url(${backgroundImageUrl})`,
         );
      }
      // Mobile solid background
      else if (!isDesktop) {
         backgroundElement.style.setProperty('--bgColor', backgroundColor);
      }
      // Desktop no image
      else {
         backgroundElement.style.setProperty('--bg', 'none');
      }
   }

   return {
      applyTenantColors,
      setBackgroundImage,
   };
}

